// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"a724680f1fb310ca569c","452":"b387e3ab3baaccfbdf05","453":"b14e98093b40cf2dc317","454":"723e6b7a547a046a5ed7","551":"63d6273783dfea10e046"}[chunkId] + ".js";
};